export default __webpack_public_path__ + "static/media/dragon.55f63497.jpg";